module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-103.fb81133e.svg";